// A custom element reconnects automatically after Shopify filtering/editor renders.
class MarksverseCardVideo extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    this.button = this.querySelector('button');
    if (!this.video || !this.button) return;
    this.abort = new AbortController();
    const options = { signal: this.abort.signal };
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.userPaused = false;
    this.explicitPlay = false;
    this.visible = false;
    this.video.muted = true;
    this.video.controls = false;
    this.button.hidden = false;
    this.updateButton = () => {
      const label = this.video.paused ? 'Play video' : 'Pause video';
      this.button.textContent = label;
      this.button.setAttribute('aria-label', label + ': Floating Money Lamp');
    };
    this.sync = () => {
      if (this.visible && !document.hidden && !this.userPaused && (!this.motion.matches || this.explicitPlay)) {
        this.video.play().catch(() => this.updateButton());
      } else this.video.pause();
      this.updateButton();
    };
    this.button.addEventListener('click', () => {
      if (this.video.paused) {
        this.userPaused = false;
        this.explicitPlay = true;
      } else {
        this.userPaused = true;
        this.explicitPlay = false;
      }
      this.sync();
    }, options);
    this.video.addEventListener('play', this.updateButton, options);
    this.video.addEventListener('pause', this.updateButton, options);
    this.video.addEventListener('error', () => { this.button.hidden = true; }, options);
    this.motion.addEventListener('change', () => { this.explicitPlay = false; this.sync(); }, options);
    document.addEventListener('visibilitychange', this.sync, options);
    this.observer = new IntersectionObserver(entries => {
      this.visible = entries[0].isIntersecting;
      this.sync();
    }, { threshold: 0.15 });
    this.observer.observe(this);
    this.updateButton();
  }
  disconnectedCallback() {
    this.abort?.abort();
    this.observer?.disconnect();
    this.video?.pause();
  }
}
if (!customElements.get('marksverse-card-video')) customElements.define('marksverse-card-video', MarksverseCardVideo);
